import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

import { LayoutModule } from '../../../layouts/layout.module';

import { TableModule } from '../../../../shared/table';
import { InvestorRoutingModule } from './investor-routing.module';
import { InvestorListComponent } from './investor-list/investor-list.component';
import { InvestorNewComponent } from './investor-new/investor-new.component';
import { InvestorDetailComponent } from './investor-detail/investor-detail.component';
import { InvestorAddressComponent } from './investor-address/investor-address.component';
import { InvestorEditComponent } from './investor-edit/investor-edit.component';
import { InvestorContactComponent } from './investor-contact/investor-contact.component';
import { ApiModule } from '../../../../_services/api.module';
import { ActionButtonModule } from '../../../../shared/action-button';
import { DatePickerModule } from '../../../../shared/date-picker';
import { BooleanSwitchModule } from '../../../../shared/boolean-switch';
import { ModalModule } from './../../../../shared/modal';
import { WidgetModule } from './../../../../shared/widget';
import { FilterModule } from './../../../../shared/filter';
import { ContainerModule } from './../../../../shared/container';
import { ListContainerModule } from './../../../../shared/list-container';
import { TabsModule } from './../../../../shared/tabs';
import { UnitTableModule } from '../units/unit-table';
import { InvestorTableModule } from './investor-table';
import { InvestorProviders } from '../../../../_models';

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
    url: 'https://httpbin.org/post',
    maxFilesize: 50,
    acceptedFiles: 'image/*'
};


@NgModule({
    imports: [
        CommonModule,
        InvestorRoutingModule,
        LayoutModule,
        TableModule,
        BlockUIModule.forRoot(),
        FormsModule,
        ReactiveFormsModule,
        DropzoneModule,
        SweetAlert2Module.forRoot(),
        ApiModule,
        ActionButtonModule,
        DatePickerModule,
        BooleanSwitchModule,
        ModalModule,
        WidgetModule,
        FilterModule,
        ContainerModule,
        ListContainerModule,
        TabsModule,
        UnitTableModule,
        InvestorTableModule
    ],
    declarations: [
        InvestorListComponent,
        InvestorNewComponent,
        InvestorDetailComponent,
        InvestorAddressComponent,
        InvestorEditComponent,
        InvestorContactComponent
    ],
    providers: [
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG
        },
        InvestorProviders
    ]
})
export class InvestorModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor.module.ts